import {StoreType} from '..';
//types
import {
	IAttentionItem,
	IOrganizationDashboardAuctionItemsResponse,
	IOrganizationDashboardCheckedInResponse,
	IOrganizationDashboardSpecialMealsResponse,
	IOrganizationDashboardStatistics,
	IOrganizationDashboardTablesSoldResponse,
	IOrganizationDashboardUnknownGuestsResponse,
} from '../../utils/types';

export const getDashboardLoadingSelector = (state: StoreType): boolean => state.organizationDashboardStore.isLoading;

export const getDashboardStatisticsSelector = (state: StoreType): IOrganizationDashboardStatistics | null =>
	state.organizationDashboardStore.statistics;

export const getDashboardTableSoldSelector = (state: StoreType): IOrganizationDashboardTablesSoldResponse =>
	state.organizationDashboardStore.tablesSold;

export const getDashboardUnknownGuestsSelector = (state: StoreType): IOrganizationDashboardUnknownGuestsResponse =>
	state.organizationDashboardStore.unknownGuests;

export const getDashboardAuctionItemsSelector = (state: StoreType): IOrganizationDashboardAuctionItemsResponse =>
	state.organizationDashboardStore.auctionItems;

export const getDashboardCheckedInSelector = (state: StoreType): IOrganizationDashboardCheckedInResponse =>
	state.organizationDashboardStore.checkedIn;

export const getDashboardSpecialMealsSelector = (state: StoreType): IOrganizationDashboardSpecialMealsResponse =>
	state.organizationDashboardStore.specialMeals;

export const getDashboardAttentionListSelector = (state: StoreType): IAttentionItem[] | [] =>
	state.organizationDashboardStore.attentionList;
